import { SubmitTraitsGenerationContract } from 'src/js/modules/element-settings/helpers/stage-contracts';
import getAdjustedTraits from './get-adjusted-traits';
import getModifiedTraits from './get-modified-traits';

const createSubmitTraitsColumnAppearanceHandler =
  ({ prefix }) =>
  (flowData, context) => {
    const { state, initialState, modifiedAttributes, lastModifiedAttributes } = context;

    const adjusted = getAdjustedTraits({
      prefix,
      modifiedAttributes,
    });
    const modified = getModifiedTraits({
      prefix,
      modifiedAttributes: lastModifiedAttributes,
      state,
      initialState,
    });

    return SubmitTraitsGenerationContract.create({ ...adjusted, ...modified });
  };

export default createSubmitTraitsColumnAppearanceHandler;
